import React from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Button, Divider, Stack, Typography } from '@mui/material';

type BackendUnavailablePageProps = {
  onRetry: () => void;
};

const BackendUnavailablePage = ({ onRetry }: BackendUnavailablePageProps) => (
  <Box
    component="main"
    sx={{
      alignItems: 'center',
      background: 'radial-gradient(circle at top, #fff 0%, #f5f7fb 60%, #eef2f6 100%)',
      display: 'flex',
      justifyContent: 'center',
      margin: 0,
      minHeight: '100vh',
      padding: 3,
      width: '100%',
    }}
  >
    <Box
      sx={{
        backgroundColor: 'white',
        border: '1px solid #dce3ed',
        borderRadius: 3,
        boxShadow: '0 20px 50px rgba(23, 35, 62, 0.12)',
        maxWidth: 500,
        padding: { xs: 4, sm: 6 },
        textAlign: 'center',
        width: '100%',
      }}
    >
      <Box alt="Sercom" component="img" src="/logo-sercom-brand.png" sx={{ height: 44, marginBottom: 4, maxWidth: '100%', objectFit: 'contain' }} />
      <Typography component="h1" sx={{ color: '#17233e', fontSize: { xs: '1.45rem', sm: '1.7rem' }, fontWeight: 700, marginBottom: 2 }}>
        We’ll be back shortly / Nous serons de retour bientôt
      </Typography>
      <Stack spacing={2} sx={{ color: '#52627c', fontSize: '1rem', lineHeight: 1.65, margin: '0 auto 2.5rem', maxWidth: 390 }}>
        <Typography>Sercom is temporarily unavailable while we restore service. Please try again in a few minutes.</Typography>
        <Divider />
        <Typography>
          Sercom est temporairement indisponible pendant que nous rétablissons le service. Veuillez réessayer dans quelques minutes.
        </Typography>
      </Stack>
      <Button onClick={onRetry} startIcon={<RefreshIcon />} sx={{ borderRadius: 2, padding: '10px 22px' }} variant="contained">
        Try again / Réessayer
      </Button>
    </Box>
  </Box>
);

export default BackendUnavailablePage;
